import "./OrganizationStructure.module.css";
import Header from "@/reusable_sections/Header";
import Hierarchy from "./sections/Hierarchy";
import Branch from "./sections/Branch";
import Units from "./sections/Units";
import Footer from "@/reusable_sections/Footer";
import Leadership from "./sections/Leadership";
export default function OrganizationStructurePage() {
  return <div>
      <Header />
      <Hierarchy />
      <Leadership />
      <Branch />
      <Units />
      <Footer />
    </div>;
}